import AboutFirstImage from "../svg/Aboutfirstimg.svg"
const AboutPic = () => {
    return (
   
  <img src={AboutFirstImage}  />


    )
  }
  export default AboutPic;